// Lib
import _ from "lodash";
import { oc } from "ts-optchain";

// Vue
import Vue from "vue";
import { mapGetters } from "vuex";

// Icons
import { faAngleLeft, faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

// Services
import { AddressBookService, ObjectUtil, ShoppingCartService, AccountService, ErrorLogService } from "@/services";
// Mixins
import { countryHelper, inputValidateState } from "@/components/mixins/";

// Components
import { DnFormInput } from "@/components/Elements";
import { AvailableDealerCodeSelector, PostalAddress, LoadingSpinner } from "@/components";
import ToolTipPopover from "@/components/Elements/ToolTipPopover.vue";
import CustomerAddressModal from "@/components/Modals/CustomerAddressModal"
import {
  LocationTypeId
} from "@/types";

export default Vue.extend({
  name: "FinalDeliveryAddressForm",
  components: {
    FontAwesomeIcon,
    ToolTipPopover,
    PostalAddress,
    AvailableDealerCodeSelector,
    LoadingSpinner,
    DnFormInput,
    CustomerAddressModal
  },
  mixins: [countryHelper, inputValidateState],
  props: {
    context: {
      type: Object,
      default: {},
    },
    customerAddressList: {
      type: Array,
      default: []
    }
  },
  data: () => ({
    finalToBranches: [],
    selectedFinalToBranchOption: null,
    selectedCustomerAddress: null,
    loadingFinalToBranches: false,
    savingNewCustomerAddress: false,
    showAddressSaveSucess: false,
    showAddressSaveFailed: false,
    addressOption: "useFinalToBranch"
  }),
  computed: {
    ...mapGetters(["activeAccountId", "availableDealerCodes", "user", "activeDealer"]),
    finalToBranchOptions() {
      const branches = _.chain(this.finalToBranches)
        .filter(x => x.AccountSalesOrg.FreightForwarderAgent != "X" && x.LocationType == LocationTypeId.Branch)
        .uniqBy((x) => x.AccountSalesOrg.SapCustomerNumber)
        .orderBy((x) => x.AccountSalesOrg.SapCustomerNumber)
        .value();

      var branchOptions = branches.map(x => ({
        text: x.AccountSalesOrg.SapCustomerNumber,
        value: x.AccountSalesOrg.SapCustomerNumber
      }))

      if (branchOptions.length > 0) {
        this.selectedFinalToBranchOption = branchOptions[0].value;
      }
      return branchOptions;
    },
    selectedFinalToBranch() {
      if (this.finalToBranches.length < 1) {
        return null;
      }
      var selectedBranch = this.finalToBranches.filter(x =>
        x.AccountSalesOrg.SapCustomerNumber == this.selectedFinalToBranchOption
      )[0];
      return selectedBranch;
    },
    selectedFinalToBranchAddress(){
      if(!this.selectedFinalToBranch)
      {
        return null;
      }
      var addresses = this.selectedFinalToBranch.Addresses;
      var partsShipToAddresses = addresses.filter(x => x.AddressType === "PartsShipTo");
      var mailingAddresses = addresses.filter(x => x.AddressType === "Mailing");

      var selectedFinalToBranchAddress = undefined as any;
      if(partsShipToAddresses.length > 0)
      {
        selectedFinalToBranchAddress = partsShipToAddresses[0];
      }
      else if(mailingAddresses.length > 0)
      {
        selectedFinalToBranchAddress = mailingAddresses[0];
      }
      else if(addresses.length > 0)
      {
        selectedFinalToBranchAddress = addresses[0]
      }

      if(selectedFinalToBranchAddress){
        var postalAddress = {
          Name: this.selectedFinalToBranch.Name,
          AddressLine1: selectedFinalToBranchAddress.Street1,
          AddressLine2: selectedFinalToBranchAddress.Street2,
          AddressLine3: selectedFinalToBranchAddress.Street3,
          City: selectedFinalToBranchAddress.City,
          StateProvinceCode: selectedFinalToBranchAddress.StateProvinceCode ?? selectedFinalToBranchAddress.StateProvince,
          PostalCode: selectedFinalToBranchAddress.PostalCode,
          CountryCode: selectedFinalToBranchAddress.CountryCode ?? selectedFinalToBranchAddress.Country
        };
        return postalAddress;
      }

      return undefined;
    },
    customerAddressOptions() {
      if(!this.customerAddressList)
      {
        return [];
      }
      const customerAddressOptions = this.customerAddressList.map(x => (
        { text: `${x.CustomerName} (${x.AddressLine1} - ${x.StateProvince} - ${x.Country})`, value: x }
      ));
;
      if(customerAddressOptions.length > 0)
      {
        this.selectedCustomerAddress = customerAddressOptions[0].value;
      }
      return customerAddressOptions;
    },
    customerPostalAddress(){
      if(!this.selectedCustomerAddress)
      {
        return null;
      }
      var postalAddress = {
        Name: this.selectedCustomerAddress.CustomerName,
        AddressLine1: this.selectedCustomerAddress.AddressLine1,
        AddressLine2: this.selectedCustomerAddress.AddressLine2,
        AddressLine3: "",
        City: this.selectedCustomerAddress.City,
        StateProvinceCode: this.selectedCustomerAddress.StateProvince,
        PostalCode: this.selectedCustomerAddress.PostalCode,
        CountryCode: this.selectedCustomerAddress.Country
      };
      return postalAddress
    }
  },
  watch: {
    "selectedCustomerAddress": function(){
      this.emitChosenAddress();
    },
    "addressOption": function(){
      this.emitChosenAddress();
    }, 
    "selectedFinalToBranchOption": function(){
      this.emitChosenAddress();
    }, 
  },
  created() {
    this.loadFinalToBranches();

    if(!this.context.addressOption){
      this.emitChosenAddress();
    }
    else{
      this.addressOptions = this.context.addressOption;
    }
    
  },
  methods: {
    emitChosenAddress(newCustomerAddress: any = null){
      var newFinalToAddress = {};
      
      if(this.addressOption === 'useFinalToBranch' && this.selectedFinalToBranchAddress)
      {
        newFinalToAddress = {
          FinalToAccount: {
            AccountCodes: [this.selectedFinalToBranch.AccountCodes[0]],
            AccountSalesOrg: this.selectedFinalToBranch.AccountSalesOrg
          },
          FinalToCustomerAddressName: this.selectedFinalToBranchAddress.Name,
          FinalToCustomerAddressName2: this.selectedFinalToBranchAddress.Name2,
          FinalToCustomerAddress1: this.selectedFinalToBranchAddress.AddressLine1,
          FinalToCustomerAddress2: this.selectedFinalToBranchAddress.AddressLine2,
          FinalToCustomerCity:this.selectedFinalToBranchAddress.City, 
          FinalToCustomerStateProvince: this.selectedFinalToBranchAddress.StateProvinceCode,
          FinalToCustomerPostalCode: this.selectedFinalToBranchAddress.PostalCode,
          FinalToCustomerCountryCode: this.selectedFinalToBranchAddress.CountryCode,
          FinalToShouldSaveCustomerAddress: false
        }

        this.$emit("updateFinalToAddress", newFinalToAddress);
      }
      else if(this.addressOption === 'useCustomerOverride' && this.selectedCustomerAddress)
      {
        newFinalToAddress = {
          FinalToAccount: {
            AccountCodes: [this.selectedFinalToBranch.AccountCodes[0]],
            AccountSalesOrg: this.selectedFinalToBranch.AccountSalesOrg
          },
          FinalToCustomerAddressName: this.selectedCustomerAddress.CustomerName,
          FinalToCustomerAddressName2: this.selectedCustomerAddress.CustomerName2,
          FinalToCustomerAddress1: this.selectedCustomerAddress.AddressLine1,
          FinalToCustomerAddress2: this.selectedCustomerAddress.AddressLine2,
          FinalToCustomerCity:this.selectedCustomerAddress.City, 
          FinalToCustomerStateProvince: this.selectedCustomerAddress.StateProvince,
          FinalToCustomerPostalCode: this.selectedCustomerAddress.PostalCode,
          FinalToCustomerCountryCode: this.selectedCustomerAddress.Country,
          FinalToShouldSaveCustomerAddress: false
        }
        this.$emit("updateFinalToAddress", newFinalToAddress);
      }
      else if (this.addressOption === 'useNewAddress' && newCustomerAddress){
        newFinalToAddress = {
          FinalToAccount: {
            AccountCodes: [this.selectedFinalToBranch.AccountCodes[0]],
            AccountSalesOrg: this.selectedFinalToBranch.AccountSalesOrg
          },
          FinalToCustomerAddressName: newCustomerAddress.CustomerName,
          FinalToCustomerAddressName2: newCustomerAddress.CustomerName2,
          FinalToCustomerAddress1: newCustomerAddress.AddressLine1,
          FinalToCustomerAddress2: newCustomerAddress.AddressLine2,
          FinalToCustomerCity: newCustomerAddress.City, 
          FinalToCustomerStateProvince: newCustomerAddress.StateProvince,
          FinalToCustomerPostalCode: newCustomerAddress.PostalCode,
          FinalToCustomerCountryCode: newCustomerAddress.Country,
          FinalToShouldSaveCustomerAddress: true
        };
        this.$emit("updateFinalToAddress", newFinalToAddress);
      }

    },
    async loadFinalToBranches() {
      this.loadingFinalToBranches = true;
      var soldTo = this.activeDealer.AccountSalesOrg.SoldToCode;

      const finalToData = await AccountService.getAccountsBySalesOrgCode(
        this.activeAccountId,
        this.user.UserId,
        soldTo
      );
      this.finalToBranches = finalToData;
      this.$emit("loadedFinalToBranches");
      this.loadingFinalToBranches = false;
    },
    async saveAddress(addressDto) {
      try {
        this.savingNewCustomerAddress = true;
        await AddressBookService.SaveCustomerAddress(
          this.activeAccountId,
          this.user.UserId,
          addressDto);

        var self = this;
        self.showAddressSaveSucess = true;
        setTimeout(function(){
          self.showAddressSaveSucess = false;
        }, 3000);
      }
      catch{
        var self = this;
        self.showAddressSaveFailed = true;
        setTimeout(function(){
          self.showAddressSaveFailed = false;
        }, 3000);
      } finally {
        this.savingNewCustomerAddress = false;
      }
    }
  }
});
